import { action } from 'typesafe-actions';

import * as types from './types';
import { SearchRequestParams } from '@interfaces/search-request-params';

export const fetchSearch = (params: SearchRequestParams) => action(types.FETCH_SEARCH, params);
export const fetchSearchSuccess = (data: any) => action(types.FETCH_SEARCH_SUCCESS, data);
export const fetchSearchError = (error: any) => action(types.FETCH_SEARCH_ERROR, error);
